import { InfoListRow, InfoListLabel, InfoListValue } from '../'

type InfoRowProps = {
  label: string
  value: string | number
  dataTest: string
}

const InfoRow: React.FC<InfoRowProps> = ({ label, value, dataTest }) => (
  <InfoListRow dataTest={dataTest}>
    <InfoListLabel>{label}</InfoListLabel>
    <InfoListValue>{value}</InfoListValue>
  </InfoListRow>
)

export default InfoRow
